/*
 * Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, HostBinding, Input } from "@angular/core";
import { MasterDetailViewComponent } from "../master-detail-view.component";

/**
 * The master part of the {@link MasterDetailViewComponent}
 */
@Component({
    selector: "bci-master-view",
    templateUrl: "./master-view.component.html",
    styleUrls: ["./master-view.component.scss"],
    standalone: false
})
export class MasterViewComponent {
  /*TODO: find a solution so that <bci-page-content> can be used in demo/solution instead of isPadded and still the sidebar is working*/
  @HostBinding("class.container-content-padded")
  @Input()
  public isPadded = true;
}
